module.exports = __webpack_public_path__ + "static/media/doc.36100a14.svg";